import React from 'react';
import { Close } from '@10d/tend-ui-icons/Close';
import { useTheme } from '@10d/tend-ui-theme';
import { useDrawerContext } from '../../contexts/DrawerContext.js';
import { Root } from './styled.js';

const CloseButton = (props) => {
    const theme = useTheme();
    const context = useDrawerContext();
    return (React.createElement(Root, Object.assign({ onClick: context === null || context === void 0 ? void 0 : context.onClose }, props, { theme: theme }),
        React.createElement(Close, { size: 20 })));
};

export { CloseButton };
//# sourceMappingURL=CloseButton.js.map
